/**
 * Geschenke product slider — port of ProductSlider in geschenke/page.tsx:
 * - arrow buttons scroll the track by ±320px (smooth)
 * - canPrev/canNext recomputed on track scroll with the 8px edge thresholds
 *   (disabled arrows render at 20% opacity via CSS)
 * The stagger reveal itself is CSS-driven (scroll-reveal .is-revealed on the
 * section + per-card transition-delay).
 */
(function () {
  'use strict';

  function initSlider(section) {
    if (section.dataset.giftInit) return;
    section.dataset.giftInit = '1';

    var track = section.querySelector('[data-gift-track]');
    var prevBtn = section.querySelector('[data-gift-prev]');
    var nextBtn = section.querySelector('[data-gift-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function update() {
      prevBtn.disabled = track.scrollLeft <= 8;
      nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 8;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -320, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: 320, behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-gift-slider]').forEach(initSlider);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
